import { isActiveCall } from '../widgetManager/utils/isActiveCall.js'
import { subscribeWithSelector } from 'zustand/middleware'
import { showAnimation } from '../utils/showAnimation.js'
import { createStore } from 'zustand/vanilla'
import { playFx } from '../utils/playFx.js'

const actionLogger = (config) => (set, get, api) => {
  const wrappedSet = (partial, replace) => set(partial, replace)

  const store = config(wrappedSet, get, api)

  return Object.entries(store).reduce((wrappedStore, [key, value]) => {
    if (typeof value === 'function') {
      wrappedStore[key] = (...args) => {
        const actionReturn = value(...args)
        if (!actionReturn) return
        window.trueengage.widgetContainer.triggerPublicEvent(actionReturn.action, actionReturn.state)
        console.log(`trigger public event: ${actionReturn.action}`, 'state:', actionReturn.state)
      }
    } else {
      wrappedStore[key] = value
    }
    return wrappedStore
  }, {})
}

export const widgetStore = createStore(
  actionLogger(
    subscribeWithSelector((set, get) => ({
      component_state: 'stand_by',
      widget_tab: null,
      widget_visibility: false,
      headsup_visibility: false,
      icon_visibility: false,

      previous_widget_tab: null,

      openWidget: () => {
        if (get().widget_visibility) return
        set({ widget_visibility: true, headsup_visibility: false })

        const action = isActiveCall(get) ? 'widget_maximize' : 'widget_opened'
        return { action, state: get() }
      },

      closeWidget: (minimize = false) => {
        if (!get().widget_visibility && get().widget_tab !== 'trueengage.form') return
        set({ widget_visibility: false })

        const action = isActiveCall(get) || minimize ? 'widget_minimize' : 'widget_closed'
        return { action, state: get() }
      },

      showIcon: () => {
        if (get().icon_visibility) return
        set({ icon_visibility: true })
        return { action: 'icon_shown', state: get() }
      },

      hideIcon: () => {
        if (!get().icon_visibility) return
        set({ icon_visibility: false })
        return { action: 'icon_hidden', state: get() }
      },

      openHeadsup: () => {
        if (get().headsup_visibility || get().widget_visibility) return
        set({ headsup_visibility: true })
        return { action: 'headsup_opened', state: get() }
      },
      closeHeadsup: (closedByUser = false) => {
        if (!get().headsup_visibility) return
        set({ headsup_visibility: false })
        const state = { ...get(), closedByUser }
        return { action: 'headsup_closed', state: state }
      },

      // TODO: `openChannel` is only used for chat auto-start. Verify if it needs to remain in the store.
      openChannel: (channelId) => {
        set({ active_channel: channelId })
        return { action: `[deprecated] Open channel + ${channelId}`, state: get() }
      },
      setWidgetTab: (tab) => {
        if (tab === get().widget_tab) return
        set((state) => ({
          widget_tab: tab,
          previous_widget_tab: state.widget_tab,
        }))
        return { action: `widget_tab_changed`, state: get() }
      },

      showAnimation: (type) => {
        showAnimation(type)
        return { action: `animation_shown`, state: get() }
      },
      playSound: (type) => {
        playFx(type)
        return { action: `sound_played`, state: get() }
      },

      // TODO: To be removed or kept for debugging. Verify where `setState` is called and replace it with direct function calls.
      setState: (partialState) => {
        set(partialState)
        return { action: 'state:update', state: get() }
      },
    }))
  )
)
